import { render, staticRenderFns } from "./recucler-dictionary-card.vue?vue&type=template&id=925c1c8c&"
import script from "./recucler-dictionary-card.vue?vue&type=script&lang=ts&"
export * from "./recucler-dictionary-card.vue?vue&type=script&lang=ts&"
import style0 from "./recucler-dictionary-card.vue?vue&type=style&index=0&id=925c1c8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports